export default "__VITE_ASSET__epXs1Z$X__";